<div class="cropper">
  <div
    #outerBox
    class="outer-box"
    tabindex="0"

    [attr.data-pixel-ratio]="pixelRatio"
    [attr.data-selection-scale]="selectionScale"

    (touchstart)="handleDragStart($event)"
    (mousedown)="handleDragStart($event)"
    (pointerdown)="handleDragStart($event)"

    (drag)="handleDragging($event)"
    (mousemove)="handleDragging($event)"
    (pointermove)="handleDragging($event)"

    (touchend)="handleDragEnd($event)"
    (mouseup)="handleDragEnd($event)"
    (pointerup)="handleDragEnd($event)"
    (pointercancel)="handleDragEnd($event)"
    (click)="handleDragEnd($event)"
    (contextmenu)="handleDragEnd($event)"
  >
    <div class="foreground fg-left"></div>
    <div class="foreground fg-right"></div>
    <div class="foreground fg-top"></div>
    <div class="foreground fg-bottom"></div>
    <div
      #innerBox
      class="inner-box"
    >
      <div class="inner-box-outline"></div>
      <img
        #image
        alt=""
        [src]="source"
        class="draggable-image"
        [style]="imageStyle"
        (load)="handleImageLoad()"
      >
    </div>
  </div>
  <div class="controls">
    <button type="button" (click)="zoomIn()">
      <mat-icon>add</mat-icon>
    </button>
    <button type="button" (click)="zoomOut()">
      <mat-icon>remove</mat-icon>
    </button>
  </div>
</div>

<canvas #output class="output" [width]="selectionSize.x" [height]="selectionSize.y"></canvas>
